import React, { useState, useEffect } from 'react';
import { Mail, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const EmailVerification = () => {
  const { user, logout } = useAuth();
  const [resendLoading, setResendLoading] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown <= 0) return;
    const interval = setInterval(() => {
      setCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [cooldown]);

  const handleResend = async () => {
    setResendLoading(true);
    setResendSuccess(false);
    try {
      await api.post('/auth/resend-verification');
      setResendSuccess(true);
      setCooldown(60);
    } catch {
      // silently fail
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-dark-surface border border-dark-border rounded-2xl p-8 space-y-6">
          <div className="w-16 h-16 rounded-full bg-blue-500/10 border border-blue-500/30 flex items-center justify-center mx-auto">
            <Mail className="h-8 w-8 text-blue-400" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-primary mb-2">
              Vérifiez votre adresse email
            </h1>
            <p className="text-secondary text-sm leading-relaxed">
              Un email de vérification a été envoyé à{' '}
              <span className="font-semibold text-primary">{user?.email}</span>.
              Cliquez sur le lien dans l'email pour activer votre compte.
            </p>
          </div>
          <div>
            <button
              onClick={handleResend}
              disabled={resendLoading || cooldown > 0}
              className="px-4 py-2 bg-blue-500/10 border border-blue-500/30 text-blue-400 rounded-lg text-sm font-medium hover:bg-blue-500/20 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {resendLoading
                ? 'Envoi...'
                : cooldown > 0
                  ? `Renvoyer (${cooldown}s)`
                  : 'Renvoyer l\'email'}
            </button>
            {resendSuccess && (
              <p className="text-green-400 text-sm mt-2">Email envoyé !</p>
            )}
          </div>
          <div className="bg-black/20 rounded-xl p-4 text-left space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-muted">Email</span>
              <span className="text-primary">{user?.email}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-muted">Statut</span>
              <span className="text-blue-400 font-medium">Non vérifié</span>
            </div>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-2 mx-auto px-4 py-2 rounded-lg text-secondary hover:text-primary transition-colors text-sm"
          >
            <LogOut className="h-4 w-4" />
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
